import { render, staticRenderFns } from "./NoPermModal.vue?vue&type=template&id=3e529c2a&scoped=true&"
import script from "./NoPermModal.vue?vue&type=script&lang=js&"
export * from "./NoPermModal.vue?vue&type=script&lang=js&"
import style0 from "./NoPermModal.vue?vue&type=style&index=0&id=3e529c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e529c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e529c2a')) {
      api.createRecord('3e529c2a', component.options)
    } else {
      api.reload('3e529c2a', component.options)
    }
    module.hot.accept("./NoPermModal.vue?vue&type=template&id=3e529c2a&scoped=true&", function () {
      api.rerender('3e529c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/NoPermModal.vue"
export default component.exports